import log from "loglevel";

// change level to DEBUG for debugging
log.setLevel("WARN", true);

export default log;
